import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;
const endpoint = `${apiUrl}/Partner/ResiliationValidation`;

const fallback = (message, data = null) => ({ status: false, message, data });

const ResiliationValidationService = {
  async getAll(params = {}) {
    try {
      const response = await axios.get(endpoint, { params });
      return response.data;
    } catch (error) {
      return error.response?.data || fallback('Erreur de chargement des demandes de resiliation', {
        rows: [], total: 0, page: 1, limit: 20,
      });
    }
  },

  async getDetail(validationId) {
    try {
      const response = await axios.get(`${endpoint}/detail/${validationId}`);
      return response.data;
    } catch (error) {
      return error.response?.data || fallback('Erreur de chargement du contrat');
    }
  },

  async approve(validationId) {
    try {
      const response = await axios.post(`${endpoint}/approve`, { validation_id: validationId });
      return response.data;
    } catch (error) {
      return error.response?.data || fallback('Erreur pendant la validation de la resiliation');
    }
  },

  async reject(validationId, reason) {
    try {
      const response = await axios.post(`${endpoint}/reject`, {
        validation_id: validationId,
        reason,
      });
      return response.data;
    } catch (error) {
      return error.response?.data || fallback('Erreur pendant le rejet de la resiliation');
    }
  },
};

export default ResiliationValidationService;
